import { render, staticRenderFns } from "./Aroma.vue?vue&type=template&id=690677b2"
import script from "./Aroma.vue?vue&type=script&lang=js"
export * from "./Aroma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports